import styled from 'styled-components';

import ButtonIcon from '../Icons/ButtonIcon';

/* hardcoded button styles to match google button */
export const SocialButton = styled(ButtonIcon).attrs({
  iconPosition: 'left',
  variant: 'defaultLight',
  isFull: true
})`
  font-family: var(--google-font), arial, sans-serif;
  letter-spacing: 0.25px;
  border: 1px solid #dadce0;
  border-radius: 4px;
  min-height: 32px;
  height: 32px;
  position: relative;
  text-transform: none;
  font-size: 14px;
  font-weight: 500;
  padding: 0;
  display: flex;
  color: #3c4043;

  &:hover {
    background-color: #f8fafe;
    border-color: #d2e3fc;
  }

  img {
    margin-left: 10px;
    height: 14px;
  }

  div {
    flex: 1;
  }
`;

export default {};
